import Grid from '@mui/material/Grid2';

interface MyGridProps {
    optionsComponent: React.ReactNode;
    contentComponent: React.ReactNode;
}

const ContenidoPerfil: React.FC<MyGridProps> = ({ optionsComponent, contentComponent }) => {
    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 3.5, md: 3.5 }}  style={{ overflow: 'auto', height: '100vh', paddingBottom: "100px" }}>
                {optionsComponent}
            </Grid>
            <Grid size={{ xs: 12, sm: 8.5, md: 8.5 }} container direction="column" style={{ overflow: 'auto', height: '100vh', paddingBottom: "100px" }}>
                <div style={{ width: '100%' }}>
                    {contentComponent}
                </div>
            </Grid>
        </Grid>
    );
};

export default ContenidoPerfil;